import { __assign, __extends } from "tslib";
import React from 'react';
function createLoadedComponentsCache() {
    var loadedComponent = [];
    return {
        get: function (loadComponent) {
            var hit = loadedComponent.find(function (_a) {
                var f = _a[0];
                return f === loadComponent;
            });
            if (hit) {
                return hit[1];
            }
            else {
                return null;
            }
        },
        set: function (loadComponent, comp) {
            return loadedComponent.push([loadComponent, comp]);
        },
    };
}
var loadWithRetry = function (loadComponent, retries) {
    if (retries === void 0) { retries = 3; }
    return loadComponent().catch(function (e) {
        if (retries > 0) {
            console.warn('loadComponent failed; reties left', retries);
            return loadWithRetry(loadComponent, retries - 1);
        }
        else {
            return Promise.reject(e);
        }
    });
};
var loadedComponents = createLoadedComponentsCache();
export var loadLazyComponent = function (loadComponent, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.loading, loading = _c === void 0 ? function () { return null; } : _c, _d = _b.resolveComponent, resolveComponent = _d === void 0 ? function (module) { return module.default; } : _d;
    var loadComponentPromise;
    var Loadable = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                Component: null,
            };
            return _this;
        }
        class_1.load = function () {
            if (!loadComponentPromise) {
                loadComponentPromise = loadWithRetry(loadComponent);
            }
            return loadComponentPromise;
        };
        class_1.getDerivedStateFromProps = function () {
            var comp = loadedComponents.get(loadComponent);
            if (comp) {
                return { Component: comp };
            }
            else {
                return null;
            }
        };
        class_1.prototype.componentDidMount = function () {
            var _this = this;
            if (!this.state.Component) {
                Loadable.load()
                    .then(function (module) {
                    var comp = resolveComponent(module);
                    loadedComponents.set(loadComponent, comp);
                    _this.setState({ Component: comp });
                })
                    .catch(function (err) { return console.error('Failed to load async component', err); });
            }
        };
        class_1.prototype.render = function () {
            var Component = this.state.Component;
            var loadableLoading = this.props.loadableLoading;
            var showLoader = loadableLoading || loading;
            return Component ? React.createElement(Component, __assign({}, this.props)) : showLoader(this.props);
        };
        return class_1;
    }(React.Component));
    return Loadable;
};
//# sourceMappingURL=load-lazy-component.js.map